import React from 'react';

import { Icons } from '@icons/icons';

import { IAcceptDeclineIconButtonsProps } from './AcceptDeclineIconButtons.types';

import colors from '@constants/colors';

import Tooltip from '../Tooltip';

import './AcceptDeclineIconButtons.scss';

const AcceptDeclineIconButtons: React.FC<IAcceptDeclineIconButtonsProps> = ({
	disabledNegative,
	disabledPositive,
	isNegativeButtonNeeded = true,
	isPositiveButtonNeeded = true,
	negativeHandler,
	positiveHandler,
	tooltipPositiveButton,
	tooltipNegativeButton,
}) => {
	return (
		<div className='f5gAcceptDeclineIconButtonsContainer'>
			{isPositiveButtonNeeded && (
				<Tooltip
					content={tooltipNegativeButton}
					isDisabled={!tooltipNegativeButton}
				>
					<div
						className='f5gAcceptDeclineIconButton'
						data-testid='acceptIconButton'
						onClick={disabledPositive ? undefined : positiveHandler}
					>
						{Icons.checkMark({ color: disabledPositive ? colors.gray40 : colors.green60 })}
					</div>
				</Tooltip>
			)}
			{isNegativeButtonNeeded && (
				<Tooltip
					content={tooltipPositiveButton}
					isDisabled={!tooltipPositiveButton}
				>
					<div
						className='f5gAcceptDeclineIconButton'
						data-testid='declineIconButton'
						onClick={disabledNegative ? undefined : negativeHandler}
					>
						{Icons.cross({ color: disabledNegative ? colors.gray40 : colors.pink50 })}
					</div>
				</Tooltip>
			)}
		</div>
	);
};

export default AcceptDeclineIconButtons;
